import type { RouteObject } from 'react-router-dom';
import { Dashboard } from '@/pages/Dashboard';
import { Welcome } from '@/pages/Welcome';
import { Routes } from '@/routes/routes';

export const generalRoutes: RouteObject[] = [
	{ path: Routes.HOME, element: <Welcome /> },
	{ path: Routes.WELCOME, element: <Welcome /> },
	{ path: Routes.DASHBOARD, element: <Dashboard /> },
];
